module.exports = __webpack_public_path__ + "static/axe_of_the_dwarvish_lords-368591f84938fbc77aa254ae26b87818.jpeg";